module.exports = "<img\n  u-cl-src=\"c_pad,h_50/{{ ::$ctrl.entity.logo_id }}.jpg\"\n  alt=\"{{ ::$ctrl.entity.name }} Logo\"\n/>\n"